import { render, staticRenderFns } from "./DragBase.vue?vue&type=template&id=6388d528&scoped=true&"
import script from "./DragBase.vue?vue&type=script&lang=js&"
export * from "./DragBase.vue?vue&type=script&lang=js&"
import style0 from "./DragBase.vue?vue&type=style&index=0&id=6388d528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6388d528",
  null
  
)

export default component.exports